import { IntercomProps } from 'react-use-intercom'

export const identifyIntercomUser = ({
  userHash,
  intercomId,
  charlieCompanyId,
  charlieCompanyName,
  updateIntercom,
  shutdownIntercom,
  isAdmin,
}: {
  userHash: string
  intercomId: string
  charlieCompanyId: string | undefined
  charlieCompanyName: string | undefined
  updateIntercom: (user: Partial<IntercomProps> | undefined) => void
  shutdownIntercom?: () => void
  isAdmin?: boolean
}) => {
  if (isAdmin && shutdownIntercom) {
    shutdownIntercom()
  } else {
    const intercomUser: Partial<IntercomProps> = {
      userHash,
      userId: intercomId,
    }

    if (charlieCompanyId && charlieCompanyName) {
      intercomUser.company = {
        companyId: charlieCompanyId,
        name: charlieCompanyName,
      }
    }

    updateIntercom(intercomUser)
  }
}
